module.exports = __webpack_public_path__ + "img/category.0a8bb20c.svg";